import { subtitleWithoutDefault } from "@redotech/redo-customer-portal-shared/util";

export function confirmationItemTitle({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}): string {
  const variantTitle = subtitleWithoutDefault(subtitle);
  return variantTitle ? `${title} - ${variantTitle}` : title;
}
